import React from 'react';

// 轻量内联图标集，避免额外依赖，统一走 currentColor 上色
const paths = {
    bell: <path d="M12 4a5 5 0 0 0-5 5v3.5L5.5 15h13L17 12.5V9a5 5 0 0 0-5-5Zm0 17a2.4 2.4 0 0 0 2.3-1.7H9.7A2.4 2.4 0 0 0 12 21Z" />,
    gear: (
        <path d="M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm8.4 3.5c0-.5 0-1-.1-1.4l1.8-1.4-1.8-3.1-2.1.8a6.6 6.6 0 0 0-1.2-.7L16.7 4h-3.4l-.3 2.2c-.4.2-.8.4-1.2.7l-2.1-.8-1.8 3.1 1.8 1.4a7 7 0 0 0 0 2.8l-1.8 1.4 1.8 3.1 2.1-.8c.4.3.8.5 1.2.7l.3 2.2h3.4l.3-2.2c.4-.2.8-.4 1.2-.7l2.1.8 1.8-3.1-1.8-1.4c.1-.4.1-.9.1-1.4Z" />
    ),
    bolt: <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z" />,
    medal: <path d="M12 2 8 8l-4 1 6 5-1 8 3-2 3 2-1-8 6-5-4-1-4-6Z" />,
    flame: <path d="M12 2s5 4 5 9a5 5 0 0 1-10 0c0-1.5.6-2.7 1.4-3.6C9 9 9 11 10.5 11.5 10 9 12 6 12 2Z" />,
    map: <path d="m9 4-6 2v16l6-2 6 2 6-2V4l-6 2-6-2Zm0 2.2 6 2v13.6l-6-2V6.2Z" />,
    puzzle: <path d="M10 3a2 2 0 0 1 4 0v1h3a1 1 0 0 1 1 1v3h1a2 2 0 0 1 0 4h-1v3a1 1 0 0 1-1 1h-3v1a2 2 0 0 1-4 0v-1H7a1 1 0 0 1-1-1v-3H5a2 2 0 0 1 0-4h1V5a1 1 0 0 1 1-1h3V3Z" />,
    brush: <path d="M14 3.5 20.5 10 12 18.5a4 4 0 0 1-4 1l-4 1 1-4a4 4 0 0 1 1-4L14 3.5Z" />,
    users: <path d="M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm8 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-8 2c-3 0-6 1.5-6 4.5V20h9v-2.5c0-1.2.5-2.3 1.3-3.1A9 9 0 0 0 8 13Zm8 0c-.6 0-1.2 0-1.7.2 1 .9 1.7 2 1.7 3.3V20h6v-2.5c0-3-3-4.5-6-4.5Z" />,
    play: <path d="M8 5v14l11-7L8 5Z" />,
    lock: <path d="M7 10V8a5 5 0 0 1 10 0v2h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h1Zm2 0h6V8a3 3 0 0 0-6 0v2Z" />,
    star: <path d="m12 2 3 6.5 7 .8-5.2 4.8 1.4 7L12 17.8 5.8 21l1.4-7L2 9.3l7-.8L12 2Z" />,
    check: <path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />,
    arrowRight: <path d="M5 12h14m-6-7 7 7-7 7" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />,
    search: <path d="M11 4a7 7 0 1 0 4.2 12.6l4.1 4.1 1.4-1.4-4.1-4.1A7 7 0 0 0 11 4Zm0 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10Z" />,
    plus: <path d="M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6V5Z" />,
    share: <path d="M16 5a3 3 0 1 0-2.8 3l-4.3 2.5a3 3 0 1 0 0 3l4.3 2.5A3 3 0 1 0 15 15l-4.3-2.5a3 3 0 0 0 0-1L15 9c.6.6 1.4 1 2.3 1A3 3 0 0 0 16 5Z" />,
    edit: <path d="M4 15.5 14.5 5 19 9.5 8.5 20H4v-4.5Zm12-12L18 5.5 20.5 3 21 3.5 18.5 6 16 3.5Z" />,
    graduation: <path d="M12 3 1 8l11 5 9-4.1V15h2V8L12 3ZM5 13v3c0 1.7 3.1 3 7 3s7-1.3 7-3v-3l-7 3-7-3Z" />
};

export default function Icon ({name, size = 24, className, title, ...rest}) {
    const glyph = paths[name];
    if (!glyph) return null;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden={title ? undefined : true}
            role={title ? 'img' : undefined}
            className={className}
            {...rest}
        >
            {title ? <title>{title}</title> : null}
            {glyph}
        </svg>
    );
}
